import MuiLink, {LinkProps} from '@mui/material/Link';

export const Link = (props: LinkProps) => {
    return (
        <MuiLink
            {...props}
        />
    )
}